import { render, staticRenderFns } from "./NicoDevice.vue?vue&type=template&id=99919c10&scoped=true&"
import script from "./NicoDevice.vue?vue&type=script&lang=js&"
export * from "./NicoDevice.vue?vue&type=script&lang=js&"
import style0 from "./NicoDevice.vue?vue&type=style&index=0&id=99919c10&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99919c10",
  null
  
)

export default component.exports